<template>
    <div id="header-desktop-detail-wrapper"
         class="toggleable pos-bottom pos-left pos-right"
         :class="{open: openedItem, closed: !openedItem}">
        <div id="header-detail-overlay"
             class="header-overlay"
             @click="$emit('close')"/>
        <!--header-detail-->
        <div class="pos-absolute pos-left pos-right bg-default-1 pt-4 pb"
             @mouseleave="$emit('close')">
            <div :id="item.id"
                 class="toggleable"
                 :class="{open: openedItem === item, closed: openedItem !== item}"
                 v-for="item in items">
                <div class="header-detail content d-flex flex-column flex-wrap">
                    <!-- detail-group -->
                    <div v-for="group in item.children"
                         class="header-collections mr"
                         :style="group.children ? 'flex: 0 0 100%' : null">
                        <template v-if="group.title">
                            <a :href="group.url"
                               v-if="group.url"
                               class="h5 mt-0"
                               :class="{'text-bold': group.children}">
                                {{ group.title }}
                            </a>
                            <p v-else
                               class="h5 mt-0"
                               :class="{'text-bold': group.children}">
                                {{ group.title }}
                            </p>
                        </template>

                        <!--header-collections-items-->
                        <nav v-if="group.children"
                             :class="{'d-flex flex-wrap': false}">
                            <a v-for="item in group.children"
                               :href="item.url"
                               class="h5"
                               style="flex: 1 1 50%; margin-top: .2em">
                                {{ item.title }}
                            </a>
                        </nav>
                    </div>

                    <!-- quebrade coluna -->
                    <div style="flex: 1 1 100%;"/>

                    <!-- detail-thumbs -->
                    <div v-if="item.thumbs"
                         class="header-detail-banners d-flex flex-align-start text-default-4 flex-justify-end overflow-hidden ml-auto">
                        <div v-for="thumb in item.thumbs"
                             class="px-2">
                            <a class="d-block pos-relative rounded overflow-hidden"
                               :href="thumb.url">
                                <img class="d-block lazy lazy-fade"
                                     :alt="thumb.alt"
                                     :data-src="`${$scope.CDN_IMAGES}/images/site/header/${thumb.image_url}?w=260&auto=format&lossless=1`">
                                <div
                                    class="pos-absolute pos-bottom pos-right mb-2 mr-2 bg-white rounded px-2 py-1 text-italic text-bold">
                                    {{ thumb.alt }}
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MenuItemDetail",

        props: {
            items: {
                type: Array,
                required: true
            },
            openedItem: Object
        }
    }
</script>